export default "__VITE_ASSET__24cca88e__"